<template>
  <v-dialog
    retain-focus
    :value="edit"
    v-on:click:outside="goToShow"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Edit JobOrder</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="editForm" v-model="createValid">
          <v-select
            :rules="validationRules.category"
            v-model="editFields.category"
            :items="categories"
            item-text="name"
            item-value="name"
            label="Item Category*"
            :error-messages="inputErrorMessages('category')"
            name="category"
            tabindex="0"
          ></v-select>

          <v-select
            :rules="validationRules.customer_id"
            v-model="editFields.customer_id"
            :items="customers"
            item-text="name"
            item-value="id"
            label="Customer*"
            :error-messages="inputErrorMessages('customer_id')"
            name="customer_id"
            tabindex="1"
          ></v-select>

          <v-text-field
            v-if="editFields.category == 'Wedding rings' || editFields.category == 'Wedding Rings'"
            :rules="validationRules.couple_name1"
            v-model="editFields.couple_name1"
            label="Couple Name 1"
            name="couple_name1"
            :error-messages="inputErrorMessages('couple_name1')"
            tabindex="2"
          ></v-text-field>

          <v-text-field
            v-if="editFields.category == 'Wedding rings' || editFields.category == 'Wedding Rings'"
            :rules="validationRules.couple_name2"
            v-model="editFields.couple_name2"
            label="Couple Name 2"
            name="couple_name2"
            :error-messages="inputErrorMessages('couple_name2')"
            tabindex="3"
          ></v-text-field>

          <v-text-field
            v-if="editFields.category == 'Wedding rings' || editFields.category == 'Wedding Rings'"
            :rules="validationRules.contact_number"
            v-model="editFields.contact_number"
            label="Contact Number/s"
            name="contact_number"
            :error-messages="inputErrorMessages('contact_number')"
            tabindex="4"
          ></v-text-field>

          <v-select
            v-if="
              editFields.category == 'Pendants, earrings, and other accessories' ||
                editFields.category == 'Pendants, Earrings, and Other Accessories'
            "
            :rules="validationRules.product_type_id"
            v-model="editFields.product_type_id"
            :items="productTypes"
            item-text="name"
            item-value="id"
            label="Product Type"
            :error-messages="inputErrorMessages('product_type_id')"
            name="product_type_id"
            tabindex="5"
          ></v-select>

          <v-text-field
            :rules="validationRules.size"
            v-model="editFields.size"
            label="Size/s"
            name="size"
            :error-messages="inputErrorMessages('size')"
            tabindex="6"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.width"
            v-model="editFields.width"
            label="Width"
            name="width"
            :error-messages="inputErrorMessages('width')"
            tabindex="7"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.thickness"
            v-model="editFields.thickness"
            label="Thickness"
            name="thickness"
            :error-messages="inputErrorMessages('thickness')"
            tabindex="8"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.weight"
            v-model="editFields.weight"
            label="Weight of Gold"
            name="weight"
            :error-messages="inputErrorMessages('weight')"
            tabindex="10"
          ></v-text-field>

          <v-select
            :rules="validationRules.karat"
            v-model="editFields.karat"
            :items="karats"
            item-text="name"
            item-value="name"
            label="Karat of Gold"
            :error-messages="inputErrorMessages('karat')"
            name="karat"
            tabindex="11"
          ></v-select>

          <v-text-field
            :rules="validationRules.color"
            v-model="editFields.color"
            label="Color of Gold"
            name="color"
            :error-messages="inputErrorMessages('color')"
            tabindex="12"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.no_of_diamond"
            v-model="editFields.no_of_diamond"
            label="No. and Size of Diamonds"
            name="no_of_diamond"
            :error-messages="inputErrorMessages('no_of_diamond')"
            tabindex="13"
          ></v-text-field>

          <v-text-field
            v-if="editFields.category == 'Wedding rings' || editFields.category == 'Wedding Rings'"
            :rules="validationRules.engraving"
            v-model="editFields.engraving"
            label="Engraving"
            name="engraving"
            :error-messages="inputErrorMessages('engraving')"
            tabindex="14"
          ></v-text-field>

          <v-text-field
            v-if="
              editFields.category == 'Engagement rings' ||
                editFields.category == 'Engagement Rings' ||
                editFields.category == 'Pendants, earrings, and other accessories' ||
                editFields.category == 'Pendants, Earrings, and Other Accessories'
            "
            :rules="validationRules.design_code"
            v-model="editFields.design_code"
            label="Design Code"
            name="design_code"
            :error-messages="inputErrorMessages('design_code')"
            tabindex="15"
          ></v-text-field>

          <v-text-field
            v-if="
              editFields.category == 'Engagement rings' ||
                editFields.category == 'Engagement Rings' ||
                editFields.category == 'Pendants, earrings, and other accessories' ||
                editFields.category == 'Pendants, Earrings, and Other Accessories'
            "
            :rules="validationRules.gia"
            v-model="editFields.gia"
            label="GIA"
            name="gia"
            :error-messages="inputErrorMessages('gia')"
            tabindex="16"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.price"
            v-model="editFields.price"
            label="Price"
            name="price"
            :error-messages="inputErrorMessages('price')"
            tabindex="17"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.cogs"
            v-model="editFields.cogs"
            label="Cost of Goods Sold"
            name="cogs"
            :error-messages="inputErrorMessages('cogs')"
            tabindex="18"
          ></v-text-field>

          <v-file-input
            chips
            multiple
            label="Upload sketches/illustration"
            v-model="editFields.files"
            name="files[]"
            :error-messages="inputErrorMessages('files')"
            tabindex="19"
          ></v-file-input>
          <div
            :key="index"
            v-for="(file, index) in editFields.current_files"
            @click="removeFile(index)"
          >
            <v-badge bordered color="error" icon="mdi-close" overlap>
              <v-img :src="'/attachement/' + file.path" max-height="50px" max-width="50px" />
            </v-badge>
          </div>

          <v-text-field
            :rules="validationRules.deposit"
            v-model="editFields.deposit"
            label="Amount Down Payment"
            name="deposit"
            :error-messages="inputErrorMessages('deposit')"
            tabindex="20"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.balance"
            v-model="editFields.balance"
            label="Amount Receivable/Balance"
            name="balance"
            :error-messages="inputErrorMessages('balance')"
            tabindex="21"
          ></v-text-field>

          <v-menu
            v-if="editFields.category == 'Wedding rings' || editFields.category == 'Wedding Rings'"
            v-model="weddingDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="weddingDateText"
                label="Wedding Date"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="weddingDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-if="editFields.category == 'Wedding rings' || editFields.category == 'Wedding Rings'"
            v-model="factoryDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="factoryDateText"
                label="Date Delivered from Factory"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="factoryDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-model="orderDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="orderDateText"
                label="Date of Order"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="orderDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-model="deliveryDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="deliveryDateText"
                label="Date picked up/purchased by customer"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="deliveryDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-model="deliveryPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="deliveryText"
                label="Pick up Date"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="delivery"></v-date-picker>
          </v-menu>

          <v-select
            v-if="editFields.category == 'Wedding rings' || editFields.category == 'Wedding Rings'"
            :rules="validationRules.rush"
            v-model="editFields.rush"
            :items="rush"
            item-text="name"
            item-value="name"
            label="Rush Order"
            :error-messages="inputErrorMessages('rush')"
            name="rush"
            tabindex="22"
          ></v-select>

          <v-textarea
            v-model="editFields.notes"
            label="Notes"
            counter="255"
            tabindex="23"
            name="notes"
          ></v-textarea>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveJobOrder">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      orderDatePicker: false,
      deliveryDatePicker: false,
      deliveryPicker: false,
      weddingDatePicker: false,
      factoryDatePicker: false,
      orderDate: '',
      deliveryDate: '',
      delivery: '',
      weddingDate: '',
      factoryDate: '',
      continousCreation: false,
      createValid: true,
      validationRules: {
        customer_id: [v => !!v || this.rem('Customer')],
        price: [
          v => !!v || this.rem('Price'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Price should be a number',
          v => v > 0 || 'Price should be greater than 0'
        ],
        cost: [
          v => !!v || this.rem('Cost'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Cost should be a number',
          v => v > 0 || 'Cost should be greater than 0'
        ],
        deposit: [
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Deposit should be a number'
        ]
      },
      errorMessages: {},
      editFields: {
        customer_id: undefined,
        couple_name1: '',
        couple_name2: '',
        contact_number: '',
        product_type_id: '',
        category: '',
        size: '',
        width: '',
        thickness: '',
        weight: '',
        karat: '',
        color: '',
        no_of_diamond: '',
        engraving: '',
        design_code: '',
        gia: '',
        price: 0,
        cogs: '',
        current_files: [],
        weddingDate: '',
        factoryDate: '',
        orderDate: '',
        deliveryDate: '',
        delivery: '',
        deposit: 0,
        balance: 0,
        rush: '',
        notes: '',
        //quantity: 1,
        cost: 0,
        deposit: 0,
        files: undefined
      }
    };
  },
  computed: {
    ...mapState({
      customers: state => state.Customer.plaincustomers,
      productTypes: state => state.ProductType.plainproductTypes,
      categories: state => state.Category.categories,
      karats: state => state.Karat.karats,
      rush: state => state.Rush.rush,
      jobOrder(state) {
        if (typeof state.JobOrder.jobOrder.data == 'undefined') {
          return {
            customer_id: undefined,
            couple_name1: '',
            couple_name2: '',
            contact_number: '',
            product_type_id: '',
            category: '',
            size: '',
            width: '',
            thickness: '',
            weight: '',
            karat: '',
            color: '',
            no_of_diamond: '',
            engraving: '',
            design_code: '',
            gia: '',
            price: 0,
            cogs: '',
            weddingDate: '',
            factoryDate: '',
            orderDate: '',
            deliveryDate: '',
            delivery: '',
            deposit: 0,
            balance: 0,
            notes: '',
            rush: '',
            //quantity: 1,
            cost: 0,
            deposit: 0
          };
        }
        let job_order = state.JobOrder.jobOrder.data;
        let todayTime = new Date(job_order['date_ordered']);
        let month = todayTime.getMonth() + 1;
        let day = todayTime.getDate();
        let year = todayTime.getFullYear();
        job_order['date_ordered'] = `${year}-${month}-${day}`;

        let deliveryTime = new Date(job_order['delivery_date']);
        let deliverymonth = deliveryTime.getMonth() + 1;
        let deliveryday = deliveryTime.getDate();
        let deliveryyear = deliveryTime.getFullYear();
        job_order['delivery_date'] = `${deliveryyear}-${deliverymonth}-${deliveryday}`;

        let deliveryDateTime = new Date(job_order['date_pickup']);
        let deliveryDatemonth = deliveryDateTime.getMonth() + 1;
        let deliveryDateday = deliveryDateTime.getDate();
        let deliveryDateyear = deliveryDateTime.getFullYear();
        job_order['date_pickup'] = `${deliveryDateyear}-${deliveryDatemonth}-${deliveryDateday}`;

        let weddingDateTime = new Date(job_order['wedding_date']);
        let weddingDatemonth = weddingDateTime.getMonth() + 1;
        let weddingDateday = weddingDateTime.getDate();
        let weddingDateyear = weddingDateTime.getFullYear();
        job_order['wedding_date'] = `${weddingDateyear}-${weddingDatemonth}-${weddingDateday}`;

        let factoryDateTime = new Date(job_order['date_delivered_from_factory']);
        let factoryDatemonth = factoryDateTime.getMonth() + 1;
        let factoryDateday = factoryDateTime.getDate();
        let factoryDateyear = factoryDateTime.getFullYear();
        job_order[
          'date_delivered_from_factory'
        ] = `${factoryDateyear}-${factoryDatemonth}-${factoryDateday}`;

        return job_order;
      }
    }),
    orderDateText() {
      return this.orderDate;
    },
    deliveryDateText() {
      return this.deliveryDate;
    },
    deliveryText() {
      return this.delivery;
    },
    weddingDateText() {
      return this.weddingDate;
    },
    factoryDateText() {
      return this.factoryDate;
    }
  },
  watch: {
    jobOrder(value) {
      this.editFields.customer_id = value.customer_id;
      if (!value.product_type_id) {
        this.editFields.product_type_id = '';
      } else {
        this.editFields.product_type_id = value.product_type_id;
      }

      this.editFields.couple_name1 = value.couple_name1;
      this.editFields.couple_name2 = value.couple_name2;
      this.editFields.contact_number = value.contact_number;
      this.editFields.price = value.price;
      //this.editFields.quantity = value.quantity;
      this.editFields.price = parseFloat(value.price);
      this.editFields.cost = parseFloat(value.cost);
      this.editFields.deposit = parseFloat(value.deposit);
      this.editFields.category = value.category;
      this.editFields.size = value.size;
      this.editFields.width = value.width;
      this.editFields.thickness = value.thickness;
      this.editFields.weight = value.weight;
      this.editFields.karat = value.karat;
      this.editFields.color = value.color;
      this.editFields.no_of_diamond = value.no_of_diamond;
      this.editFields.engraving = value.engraving;
      this.editFields.design_code = value.design_code;
      this.editFields.gia = value.gia;
      this.editFields.price = parseFloat(value.price);
      this.editFields.cogs = parseFloat(value.cogs);
      this.editFields.current_files = value.files;
      this.editFields.deposit = parseFloat(value.deposit);
      this.editFields.balance = parse_Float(value.balance);
      this.weddingDate = value.wedding_date;
      this.factoryDate = value.date_delivered_from_factory;
      this.orderDate = value.date_ordered;
      this.deliveryDate = value.date_pickup;
      this.delivery = value.delivery_date;
      this.editFields.rush = value.rush;
      this.editFields.notes = value.notes;
    }
  },
  mounted() {
    this['JobOrder/getJobOrder']({ id: this.$route.params.id });
    this['Customer/fetchCustomers']({ dontPaginate: false });
    this['ProductType/fetchProductTypes']({ dontPaginate: false });
    this['Category/fetchCategories']({ dontPaginate: false });
    this['Karat/fetchKarats']({ dontPaginate: false });
    this['Rush/fetchRush']({ dontPaginate: false });
  },
  props: {
    edit: false,
    page: 0
  },
  methods: {
    ...mapActions([
      'JobOrder/fetchJobOrders',
      'JobOrder/getJobOrder',
      'Customer/fetchCustomers',
      'ProductType/fetchProductTypes',
      'Category/fetchCategories',
      'Karat/fetchKarats',
      'Rush/fetchRush'
    ]),
    clearCreate() {},
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveJobOrder() {
      if (1 == 1 || this.$refs.editForm.validate()) {
        //console.log(this.editFields);
        //console.log(this.$route.params.id);
        const formData = new FormData(this.$refs.editForm.$el);
        formData.append('customer_id', this.editFields.customer_id);
        formData.append('product_type_id', this.editFields.product_type_id);
        formData.append('category', this.editFields.category);
        formData.append('karat', this.editFields.karat);
        formData.append('rush', this.editFields.rush);
        formData.append('remaining_files', JSON.stringify(this.editFields.current_files));
        formData.append('weddingDate', this.weddingDate);
        formData.append('factoryDate', this.factoryDate);
        formData.append('orderDate', this.orderDate);
        formData.append('deliveryDate', this.deliveryDate);
        formData.append('delivery', this.delivery);

        axios
          //.put(`api/v1/joborder/${this.$route.params.id}`, this.editFields)
          .post(`api/v1/joborder/${this.$route.params.id}/updateJobOrder`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Job Order saved...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.editForm.resetValidation();
            this['JobOrder/fetchJobOrders']({ page: this.page });
            this.$router.push('/joborder');
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    },
    removeFile(index) {
      //console.log('asfd');
      this.editFields.current_files.splice(index, 1);
    },
    goToShow() {
      this.$router.push(`/joborder/${this.$route.params.id}`);
    }
  }
};
</script>
